module.exports = __webpack_public_path__ + "img/car1_1.8610ce1f.png";